enum DateTimeframeType {
    SpecificDates = 'SpecificDates',
    CustomAttributes = 'CustomAttributes',
    Both = 'Both',
}

export default DateTimeframeType;
